import { useEffect, useState } from "react";
import type { MassPayload } from "../types/mass";
import { apiGet } from "./api";

interface State {
  data: MassPayload | null;
  error: string | null;
  loading: boolean;
}

export function useMass(id: string | undefined): State {
  const [state, setState] = useState<State>({
    data: null,
    error: null,
    loading: true,
  });

  useEffect(() => {
    if (!id) {
      setState({ data: null, error: "missing mass id", loading: false });
      return;
    }
    let cancelled = false;
    apiGet<MassPayload>(`/masses/${id}`)
      .then((data) => {
        if (!cancelled) setState({ data, error: null, loading: false });
      })
      .catch((err: Error) => {
        if (!cancelled) setState({ data: null, error: err.message, loading: false });
      });
    return () => {
      cancelled = true;
    };
  }, [id]);

  return state;
}
